import {
  colorVariants,
  genPageTheme,
  pageTheme,
  shapes,
} from '@backstage/theme';

// @backstage/theme's built-in pageTheme only covers a handful of spec.type
// values (service, website, library, tool, ...). Any Template or Component
// with a type outside that list falls back to the same default color, which
// is why our custom types (client, tooling, identity-management, access) all
// looked identical on catalog/scaffolder tiles. Extending the map here gives
// each of our categories a distinct, consistent color.
export const templatePageTheme = {
  ...pageTheme,
  client: genPageTheme({
    colors: colorVariants.eveningSea,
    shape: shapes.wave,
  }),
  tooling: genPageTheme({
    colors: colorVariants.purpleSky,
    shape: shapes.round,
  }),
  'identity-management': genPageTheme({
    colors: colorVariants.pinkSea,
    shape: shapes.wave2,
  }),
  access: genPageTheme({
    colors: colorVariants.toastyOrange,
    shape: shapes.square,
  }),
};
